import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// Import your authentication hook/context
import { AuthContext } from '../../context/AuthContext'; // Adjusted path

const AdminRoute = () => {
  // Get user and loading state from auth context
  const { user, loading } = useContext(AuthContext); 
  // Remove placeholder variables
  // const user = { role: 'admin' }; // !! Replace with actual user object !!
  // const loading = false; // !! Replace with actual loading state !!

  if (loading) {
    // Show a loading indicator while checking auth status from context
    return <div>Loading Auth Status...</div>;
  }

  // Check if user is loaded, exists, and has the 'admin' role
  const isAdmin = user && user.role === 'admin';

  return isAdmin ? <Outlet /> : <Navigate to="/login" replace />;
  // If not admin, redirect to login page
};

export default AdminRoute; 